<template>
    <div class="bg">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center">
                    <h1>{{$t('homepage.choose_your_role')}}</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-5">
                    <div class="bg__subcontainer">
                        <h2>{{$t('homepage.evaluator')}}</h2>
                        <p class="text-left" v-html="$t('homepage.evaluator_explanation')"></p>
                        <p><router-link :to="{ name: 'evaluation-students' }" class="button--outline is-orange">{{$t('homepage.evaluator_button_text')}}</router-link></p>
                        <img src="/static/img/smileys/smiley-edit--gray.png" height="155px"/>
                    </div>
                </div>
                <div class="hidden-xs hidden-sm col-md-1"></div>
                <div class="hidden-xs hidden-sm col-md-1 has-border-left"></div>
                <div class="col-xs-12 col-md-5">
                    <div class="bg__subcontainer">
                        <h2>{{$t('homepage.student')}}</h2>
                        <p class="text-left" v-html="$t('homepage.student_explanation')"></p>
                        <p>
                            <a class="button--outline is-orange" :href="$t('homepage.goto_button_url')">{{$t('homepage.goto_button_text')}}</a>
                            <a class="button--outline is-orange" :href="$t('homepage.student_button_url')">{{$t('homepage.student_button_text')}}</a>
                        </p>
                        <img src="/static/img/smileys/smiley-success--gray.png" height="155px"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component
    export default class Homepage extends Vue {
        name = 'homepage';
    }

    Vue.component('homepage', Homepage);
</script>



// WEBPACK FOOTER //
// src/pages/Homepage.vue